"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MAX_COORD = 180;
var MIN_COORD = -MAX_COORD;
var NORMALIZER = 2 * MAX_COORD;

var normalizeCoordinate = function normalizeCoordinate(coordinate) {
  if (coordinate >= MIN_COORD && coordinate <= MAX_COORD) {
    return coordinate;
  } // We need to either add or subtract 360 in order to go back to the [-180,180] range


  var sign = coordinate < 0 ? 1 : -1;
  return coordinate + sign * NORMALIZER;
};

var _default = normalizeCoordinate;
exports["default"] = _default;